var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","disabled":_vm.sending},on:{"click":function($event){return _vm.openViewerWeb(_vm.model)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-eye ")]),_vm._v(" Ver imágenes ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }